/**
 * FunctionModel
 * @classdesc Elemento con la estructura de las funciones
 * @prop {number} Id Identificador de la funci�n
 * @prop {string} Name Nombre de la funci�n
 * @prop {string} Description Descripci�n de la funci�n
 * @prop {number} Function_Id Relaci�n con una funci�n padre
 */
export default class FunctionModel {
  Id: number;
  Name: string;
  Description: string;
  Function_Id: number | null;

  constructor(args?: any) {
    this.Id = args?.id || args?.Id || args?.ID || 0;
    this.Name = args?.name || args?.Name || args?.NAME || "";
    this.Description = args?.description || args?.Description || args?.DESCRIPTION || "";
    this.Function_Id = args?.function_Id || args?.function_id || args?.Function_Id || args?.FUNCTION_ID || null;
  }
}
